import { useEffect, useState } from 'react'
import styles from './styles.module.css'

import {
  getBusinessByLogin,
  postBusiness,
  putBusiness,
} from '../../../services/business'
import {
  getAllBusinessNiche,
  postBusinessNiche,
  putBusinessNiche,
} from '../../../services/businessNicheService'
import { notifyErrorCustom } from '../../../utils/notify'

import { motion } from 'framer-motion'
import { BusinessService } from '../../../services'

import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'
import { FooterNaviBar } from '../../../components/FooterNaviBar'
import Loading from '../../../components/Loading'

const storage = window.localStorage

const STEPS = {
  STEP_PASS_ADDRESS: 'stepAddress',
  //STEP_PASS_COLOR_PALETTE: 'StepColorPalette',
  STEP_PASS_BUSINESS_INFO: 'stepBusinessInfo',
  STEP_PASS_COLOR_PALETTE: 'StepColorPalette',
  STEP_BRANDING: 'stepBranding',
}
function StepNIcheAndObjective({
  setStep,
  setBusinessAccountData,
  objectiveSelected,
  setObjectiveSelected,
  changesStep,
}) {
  const { t } = useTranslation()

  const [nicheSelected, setNicheSelected] = useState('')
  const [nicheSelectedLabel, setNicheSelectedLabel] = useState('')

  const [businessDescription, setBusinessDescriprion] = useState('')

  const [otherNicheValue, setOtherNicheValue] = useState('')

  const [primeiraMetade, setPrimeiraMetade] = useState([])
  const [segundaMetade, setSegundaMetade] = useState([])
  const [loading, setLoading] = useState(false)
  const [businessAccount, setBusinessAccount] = useState(false)
  const location = useLocation()
  const navigation = useNavigate()

  const objetiveOptions =
    storage.i18nextLng == 'en'
      ? [
        { label: 'Engagement', value: 0 },
        { label: 'Sales', value: 1 },
        { label: 'Range', value: 2 },
        { label: 'Launch', value: 3 },
      ]
      : [
        { label: 'Engajamento', value: 0 },
        { label: 'Vendas', value: 1 },
        { label: 'Alcance', value: 2 },
        { label: 'Lançamento', value: 3 },
      ]

  const businessList = [
    {
      value: 'Advocacia e Serviços Jurídicos',
      valueEn: 'Law and Legal Services',
      valueEs: 'Servicios Legales y Abogacía',
    },
    {
      value: 'Agricultura e Agronegócio',
      valueEn: 'Agriculture and Agribusiness',
      valueEs: 'Agricultura y Agronegocios',
    },
    { value: 'Alimentos e Bebidas', valueEn: 'Food and Beverages', valueEs: 'Alimentos y Bebidas' },
    { value: 'Alimentos Orgânicos', valueEn: 'Organic Food', valueEs: 'Alimentos Orgánicos' },
    { value: 'Arte e Cultura', valueEn: 'Art and Culture', valueEs: 'Arte y Cultura' },
    { value: 'Automotivo', valueEn: 'Automotive', valueEs: 'Automotriz' },
    { value: 'Barbearia', valueEn: 'Barbershop', valueEs: 'Barbería' },
    { value: 'Beleza e Salão', valueEn: 'Beauty and Salon', valueEs: 'Belleza y Salón' },
    { value: 'Cafeteria', valueEn: 'Cafeteria', valueEs: 'Cafetería' },
    {
      value: 'Coaching e Desenvolvimento Pessoal',
      valueEn: 'Coaching and Personal Development',
      valueEs: 'Coaching y Desarrollo Personal',
    },
    { value: 'Educação', valueEn: 'Education', valueEs: 'Educación' },
    { value: 'Entretenimento', valueEn: 'Entertainment', valueEs: 'Entretenimiento' },
    { value: 'Esportes e Fitness', valueEn: 'Sports and Fitness', valueEs: 'Deportes y Fitness' },
    {
      value: 'Imóveis e Construção Civil',
      valueEn: 'Real Estate and Construction',
      valueEs: 'Bienes Raíces y Construcción',
    },
    { value: 'Indústria Farma', valueEn: 'Pharmaceutical Industry', valueEs: 'Industria Farmacéutica' },
    { value: 'Joias', valueEn: 'Jewelry', valueEs: 'Joyería' },
    { value: 'Jogos / Gaming', valueEn: 'Games / Gaming', valueEs: 'Juegos / Gaming' },
    { value: 'Marketing e Publicidade', valueEn: 'Marketing and Advertising', valueEs: 'Marketing y Publicidad' },
    { value: 'Moda e Vestuário', valueEn: 'Fashion and Clothing', valueEs: 'Moda y Vestimenta' },
    { value: 'Móveis e Decoração', valueEn: 'Furniture and Decoration', valueEs: 'Muebles y Decoración' },
    { value: 'Pet Care', valueEn: 'Pet Care', valueEs: 'Cuidado de Mascotas' },
    { value: 'Saúde e Bem-estar', valueEn: 'Health and Well-being', valueEs: 'Salud y Bienestar' },
    { value: 'Serviços Empresariais', valueEn: 'Business Services', valueEs: 'Servicios Empresariales' },
    { value: 'Serviços Financeiros', valueEn: 'Financial Services', valueEs: 'Servicios Financieros' },
    { value: 'Serviços de RH', valueEn: 'HR Services', valueEs: 'Servicios de RRHH' },
    {
      value: 'Sustentabilidade e Energia',
      valueEn: 'Sustainability and Energy',
      valueEs: 'Sostenibilidad y Energía',
    },
    { value: 'Tecnologia', valueEn: 'Technology', valueEs: 'Tecnología' },
    { value: 'Viagem e Turismo', valueEn: 'Travel and Tourism', valueEs: 'Viajes y Turismo' },
    { value: 'Designers', valueEn: 'Designers', valueEs: 'Diseñadores' },
    { value: 'Notícias e Jornalismo', valueEn: 'News and Journalism', valueEs: 'Noticias y Periodismo' },
    { value: 'Política', valueEn: 'Politics', valueEs: 'Política' },
    { value: 'Outro', valueEn: 'Other', valueEs: 'Otro' },
  ]

  useEffect(() => {
    loadBusinessNiches()
  }, [])

  const loadBusinessNiches = async () => {
    const storage = window.localStorage
    let data = await getAllBusinessNiche()
    const business = await BusinessService.getBusinessByLogin()

    if (business.data.length > 0) {
      setBusinessAccount(business)
      setNicheSelected(business.data[0]?.businessNicheId)
      setNicheSelectedLabel(business.data[0]?.otherNicheName ? 'Outro' : '')
      setOtherNicheValue(business.data[0]?.otherNicheName)

      setBusinessDescriprion(business.data[0].description)
    }

    if (data.data.length <= 0) {
      for (const niche of businessList) {
        const bodyNiche = {
          name: niche.value,
          description: niche.value,
          descriptionEn: niche.valueEn,
          descriptionEs: niche.valueEs || niche.value,
        }
        await postBusinessNiche(bodyNiche)
      }
      const { data, responseStatus } = await getAllBusinessNiche()

      if (responseStatus === 200) {
        divideArray(
          data
            .map((e) => ({
              label:
                storage.i18nextLng == 'en'
                  ? e.descriptionEn
                  : storage.i18nextLng == 'es'
                    ? e.descriptionEs || e.description
                    : e.description,
              value: e.uuid,
            }))
            .sort((a, b) => a.label.localeCompare(b.label, undefined, { sensitivity: 'base' }))
        )
      }
    } else {
      if (!data.data[0].descriptionEn) {
        let i = 0
        for (const niche of businessList) {
          const bodyNiche = {
            name: niche.value,
            description: niche.value,
            descriptionEn: niche.valueEn,
            descriptionEs: niche.valueEs || niche.value,
          }
          await putBusinessNiche(data.data[i].uuid, bodyNiche)
          i++
        }
        data = await getAllBusinessNiche()
      }

      if (data.responseStatus === 200) {
        divideArray(
          data.data
            .map((e) => ({
              label:
                storage.i18nextLng == 'en'
                  ? e.descriptionEn
                  : storage.i18nextLng == 'es'
                    ? e.descriptionEs || e.description
                    : e.description,
              value: e.uuid,
            }))
            .sort((a, b) => a.label.localeCompare(b.label, undefined, { sensitivity: 'base' }))
        )
      }
    }
  }

  const divideArray = async (array) => {
    // Ponto de divisão
    const splitIndex = Math.ceil(array.length / 2)

    // Dividir o array
    setPrimeiraMetade(array.slice(0, splitIndex))
    setSegundaMetade(array.slice(splitIndex))
  }

  const handleNavigate = async (type) => {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
    if (type === 'next') {
      // if (objectiveSelected === "") {
      //   notifyErrorCustom(
      //     t("fast_publishing_choose_an_objective_for_your_post")
      //   );
      //   return;
      // }

      if (nicheSelected === '') {
        notifyErrorCustom(t('fast_publishing_choose_a_niche_for_your_post'))
        return
      }

      // if (subNicheSelected === "") {
      //   notifyErrorCustom(
      //     t("fast_publishing_include_a_subniche_for_your_post")
      //   );
      //   return;
      // }

      await createBusiness()

      const isVisualIdentityFlow =
        location.pathname === '/FastPublishing1' ||
        location.state?.parametersComplete

      if (isMobile && !isVisualIdentityFlow) {
        setStep(STEPS.STEP_BRANDING)
      } else {
        setStep(STEPS.STEP_PASS_COLOR_PALETTE)
      }
    } else if (location.pathname === '/FastPublishing1') {
      navigation('/ChatSocket')
    } else {
      navigation('/ChatSocket')
    }
  }

  const createBusiness = async () => {
    if (
      (nicheSelectedLabel === 'Outro' || nicheSelectedLabel === 'Other' || nicheSelectedLabel === 'Otro') &&
      !otherNicheValue
    ) {
      notifyErrorCustom(t('Você precisa digitar seu nicho'))
      setLoading(false)
      return
    }
    let body = {
      businessNicheId: nicheSelected,
      subNiche: '',
      description: businessDescription,
      otherNicheName: ['Outro', 'Other', 'Otro'].includes(nicheSelectedLabel)
        ? otherNicheValue
        : '',
    }

    const responseBusines = await getBusinessByLogin()

    let businessAccount

    if (responseBusines.data.length > 0) {
      await putBusiness(responseBusines?.data[0]?.uuid, body)
      businessAccount = await getBusinessByLogin()
    } else {
      businessAccount = await postBusiness(body)
    }

    setBusinessAccountData(businessAccount)
  }

  return (
    <div className={styles.motion_wrapper}>
      <motion.div
        initial={{ x: '100%' }}
        animate={{ x: 0 }}
        exit={{ x: '-100%' }}
        transition={{ type: 'tween', duration: 0.5 }}
        style={{
          width: '100%',
          minWidth: 0,
          maxWidth: '100%',
        }}
      >
      <Loading enable={loading} />
      <div className={styles.box_step}>
        <div className={styles.box_page}>
          <h1 style={{ marginTop: '0px', fontSize: '45px', fontWeight: 500, textAlign: 'center' }}>
            {t('fast_publishing_niche_and_objective')}
          </h1>

          {/* <div className={styles.container_objective}>
            <p className={styles.module_title}>
              {t("fast_publishing_define_your_objective")}
            </p>
            
            <div className={styles.box_objective}>
              {objetiveOptions.map((objective, index) => (
                <div
                  className={
                    objectiveSelected?.value === objective?.value
                      ? styles.objective_selected
                      : styles.objective
                  }
                  key={index}
                  onClick={() => setObjectiveSelected(objective)}
                >
                  <div className={styles.box_icon}>
                    <UserGroup
                      color={
                        objectiveSelected?.value === objective?.value
                          ? "#fff"
                          : "#A7A7A7"
                      }
                    />
                  </div>

                  <p
                    className={
                      objectiveSelected?.value === objective?.value
                        ? styles.objective_text_selected
                        : styles.objective_text
                    }
                  >
                    {objective.label}
                  </p>
                </div>
              ))}
            </div>
          </div> */}

          {objectiveSelected && (
            <div className={styles.container_niche}>
              <p className={styles.module_title}>
                {t('fast_publishing_now_choose_your_niche')}
              </p>

              <div className={styles.box_niche}>
                <div className={styles.box_niche_inner}>
                  <div className={styles.niche_row}>
                    {primeiraMetade.map((niche, index) => (
                      <div
                        className={
                          businessAccount?.data?.businessNicheId ??
                            nicheSelected === niche.value
                            ? styles.niche_selected
                            : styles.niche
                        }
                        key={index}
                        onClick={() => {
                          setNicheSelected(niche?.value)
                          setNicheSelectedLabel(niche?.label)
                          changesStep.current = true
                        }}
                      >
                        <p className={styles.niche_label}>{niche.label}</p>
                      </div>
                    ))}
                  </div>

                  <div className={styles.niche_row}>
                    {segundaMetade.map((niche2, index2) => (
                      <div
                        className={
                          nicheSelected === niche2.value
                            ? styles.niche_selected
                            : styles.niche
                        }
                        key={index2}
                        onClick={() => {
                          setNicheSelected(niche2?.value)
                          setNicheSelectedLabel(niche2?.label)
                          changesStep.current = true
                        }}
                      >
                        <p className={styles.niche_label}>{niche2.label}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          )}

          {(nicheSelectedLabel === 'Outro' ||
            nicheSelectedLabel === 'Other' ||
            nicheSelectedLabel === 'Otro') && (
            <div className={styles.container_subniche}>
              <p className={styles.module_title}>
                {t('step_business_information.other_niche')}
              </p>
              <input
                className={styles.box_input}
                type="text"
                value={otherNicheValue}
                placeholder={t('step_business_information.other_niche')}
                onChange={(e) => {
                  setOtherNicheValue(e.target.value)
                  // changesStep.current = true
                }}
              />
            </div>
          )}

          {nicheSelected && (
            <div className={styles.container_subniche}>
              <p className={styles.module_title}>
                {t('fast_publishing_enter_your_business_description')}
              </p>
              <textarea
                className={styles.textarea_subniche}
                type="text"
                value={businessDescription}
                placeholder={t('fast_publishing_your_business_description')}
                onChange={(e) => {
                  setBusinessDescriprion(e.target.value)
                  changesStep.current = true
                }}
              />
            </div>
          )}
        </div>

        <FooterNaviBar
          back={() => handleNavigate('back')}
          next={() => handleNavigate('next')}
        />
      </div>
    </motion.div>
    </div>
  )
}

export default StepNIcheAndObjective
